import React from "react";
import { Link } from "react-router-dom";

export default function WearCultureCta() {
  return (
    <div className="newsletter-wrap">
      <div className="newsletter-card cta-banner">
        <h2>Wear the Culture</h2>
        <p>Shop official merchandise from your favorite artists — apparel, accessories, and limited drops.</p>
        <Link to="/shop" className="btn-mu-dark" style={{ width: "auto", display: "inline-block" }}>
          Shop Now &rarr;
        </Link>
      </div>
    </div>
  );
}
